<template>
  <div class="mobile-page">
    <div class="mobile-content">
      <div v-for="tab in tabs" :key="tab.name">
        <component
          v-bind:is="tab.comp"
          class="mobile-tab scroll-tab"
          :id="tab.name"
        ></component>
      </div>
      <footer class="footer scroll-tab text-smaller text_align_center">
        All works@Poulami {{ year }}
      </footer>
    </div>

    <site-menu @navUpdated="updateTab" />
  </div>
</template>

<script>
import { mobileContentList } from '@/contents/contents.js'
import SkeletonBox from '../components/childComps/SkeletonBox.vue'
import lazyLoadComponent from '../utils/lazy-components'
const defaultOptions = {
  loading: SkeletonBox
}

import SiteMenu from '../components/childComps/SiteMenu.vue'
export default {
  data() {
    return {
      tabs: mobileContentList,
      activeTab: 'home/WebsiteLanding'
    }
  },
  components: {
    SiteMenu,
    ...mobileContentList.reduce((result, item) => {
      result[item.comp] = lazyLoadComponent({
        ...defaultOptions,
        componentFactory: () => import(`../components/${item.route}.vue`)
      })

      return result
    }, {})
  },
  computed: {
    comp: function() {
      let path = this.activeTab
      return () => import(`@/components/${path}.vue`)
    },
    year: () => {
      let today = new Date()
      return today.getFullYear()
    },
  },
  mounted: function() {},
  methods: {
    updateTab: function(tab) {
      document.getElementById(tab).scrollIntoView()
      this.activeTab = tab
    }
  }
}
</script>

<style scoped>
html {
}
.mobile-page {
  width: 100%;
  height: 100vh;
  height: -webkit-fill-available;
  position: relative;
  overflow: hidden;
}
.mobile-content {
  width: 100%;
  height: 100vh;
  //overflow-x: hidden;
  overflow-y: scroll;
  padding-bottom: 12vh;
  //scroll-snap-type: y proximity;
}
.mobile-tab {
  max-width: 100%;
  overflow-x: hidden;
  min-height: 100vh;
  border-bottom: 0.2rem solid var(--primary-color);
  padding-bottom: var(--padding-sm);
}
.mobile-tab:last-of-type {
  border-bottom: none;
}
.footer {
  margin-bottom: 6.4rem;
}
.scroll-tab {
  //scroll-snap-align: start;
}
</style>
